import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadComprobantesGastos } from '../../../store/slices/configuracionesSlice';
import ComprobantesConfigBody from './ComprobantesConfigBody';

const ComprobantesGastos = (props) => {
  const dispatch = useDispatch();
  const comprobantes = useSelector(state => state.configuraciones.comprobantesGastos.items);
  const loading = useSelector(state => state.configuraciones.comprobantesGastos.loading);
  const onLoad = (empresaId) => dispatch(loadComprobantesGastos(empresaId));
  const {
    empresaId,
    onChangeValue,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <ComprobantesConfigBody
      comprobantes={comprobantes}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

export default ComprobantesGastos;